import React, { Component } from 'react';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import { canShowMenuItem, hasPermission, isAdmin } from '@/utils/permission';

class MenuItem extends Component {

    render() {
        const { item, authUser, ...restProps } = this.props;

        const isVisible = (() => {
            if (item.isAdminOnly && !isAdmin(authUser)) return false;

            if (!item.permission) return true;

            // Nếu có action chỉ định → kiểm tra action
            if (item.action) {
                return hasPermission(authUser, item.permission, item.action);
            }

            // Mặc định là cần quyền "list"
            return canShowMenuItem(authUser, item);
        })();

        if (!isVisible) return null;

        return (
            <Menu.Item {...restProps} key={item.path} icon={item.icon}>
                {item.name}
            </Menu.Item>
        );
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        config: state.config
    };
}

export default connect(mapStateToProps)(MenuItem);